import { makeStyles } from '@material-ui/styles';
import type { Theme } from '@bizzabo/design-system';
import { CSS_TRANSITION_DELAY } from '../const';

export const useStyles = makeStyles<Theme>(
    () => ({
        navigation: {
            padding: '25px 32px',
            backgroundColor: 'transparent',
            '& > ul': {
                listStyle: 'none',
                paddingLeft: 0,
                marginTop: 36,
                marginBottom: 44,
                '& > li': {
                    marginBottom: 20,
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    '& > a': {
                        display: 'inline-block',
                        marginBottom: 6,
                    },
                },
            },
            transition: 'all 300ms ease-in',
            animation: `$appear ${CSS_TRANSITION_DELAY}ms ease`,
        },
        mySettingsLink: {
            width: '100%',
        },
        navigationDisappear: {
            animation: `$disappear ${CSS_TRANSITION_DELAY}ms ease`,
        },
        moreInfoIcon: {
            transform: 'scale(0.9) translate(2px, 9px)',
        },
        mySettingsIcon: {
            float: 'right',
        },
        signOut: {
            color: '#CB3046',
        },
        secondList: {
            listStyle: 'none',
            paddingLeft: 0,
            marginTop: 50,
            marginBottom: 44,
        },
        secondLi: {
            marginBottom: 16,
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
        },
        '@keyframes disappear': {
            '0%': {
                opacity: 1,
            },
            '100%': {
                opacity: 0,
            },
        },
        '@keyframes appear': {
            '0%': {
                opacity: 0,
            },
            '100%': {
                opacity: 1,
            },
        },
    }),
    { classNamePrefix: 'drawer-navigation-nav' }
);
